<template src="./FormStep3.html"></template>
<style lang="scss" src="./FormStep3.scss"></style>
<script>
import _ from 'lodash'

export default {
    name: 'FormStep3',

    data () {
        return {
            errors: [],
            values: {
                Nome_Iban: '',
                Cognome_Iban: '',
                CodFiscale_Iban: '',
                TitolaritàConto: true,
                Paperless: '',
                Iban: '',
                CF: '',
                End_Doc: '', // string
                Num_Doc: '',
                Tipo_Doc: '',
                MetodoPagamento: '',
                PIVA: '',
                CUU: '',
                PEC: ''
            },
            end_doc: null, // date
            documenti: ['CI', 'PAT', 'PASS'],
            metodiPagamento: ['CC', 'BOL'],
        }
    },

    computed: {
        form () {
            return this.$store.state.form
        },

        formValues() {
            return this.$store.state.form.values
        },

        Cog_RagSoc() {
            return this.$store.state.form.values.Cog_RagSoc
        },

        Nome() {
            return this.$store.state.form.values.Nome
        },

        paperlessRequired() {
            return this.$store.state.paperlessRequired
        },

        strings () {
            return this.$store.state.strings
        },

        svg () {
            return this.$store.state.svg
        },

        token() {
            return this.$store.state.token
        }
    },

    watch: {
        'values.End_Doc'(value) {
            if (value && !this.end_doc) {
                const dateSplit = value.split('/')
                const day = parseInt(dateSplit[0])
                const month = parseInt(dateSplit[1])
                const year = parseInt(dateSplit[2])
                this.end_doc = new Date(`${year}/${month}/${day}`)
            }
        },

        'values.CF'(value) {
            if (this.values.TitolaritàConto) {
                this.values.CodFiscale_Iban = value
            }
        },

        end_doc(value) {
            if (!value instanceof Date) {
                return
            }

            const day = (value.getDate() < 10) ? `0${value.getDate()}` : value.getDate()
            const month = ((value.getMonth() + 1) < 10) ? `0${value.getMonth() + 1}` : value.getMonth() + 1
            const year = value.getFullYear()

            this.values.End_Doc = `${day}/${month}/${year}`
        },

        formValues() {
            this.$updateValuesFromStore()
        }
    },

    mounted() {
        this.$updateValuesFromStore()
        this.$watch(() => this.values.TitolaritàConto, value => { this.titContoCopy(value) })
        this.titContoCopy(this.values.TitolaritàConto)

        if (this.paperlessRequired) {
            this.values.Paperless = "SI"
        }
    },

    methods: {
        titContoCopy(value) {
            if (value) {
                this.values.Nome_Iban = this.Nome
                this.values.Cognome_Iban = this.Cog_RagSoc
                this.values.CodFiscale_Iban = this.values.CF
            } else {
                this.values.Nome_Iban = ''
                this.values.Cognome_Iban = ''
                this.values.CodFiscale_Iban = ''
            }
        },

        saveAndRedirect() {
            let objToken = JSON.parse(localStorage.getItem('agsmToken'))
            objToken.retrieveData = true
            localStorage.setItem('agsmToken', JSON.stringify(objToken))
            window.location.href = this.$store.state.saveAndRedirectUrl
        },

        submit () {
            this.validation()
            if (this.token && !this.errors.length) {
                let data = {
                    tokenId: this.token,
                    step: 3,
                    fields: _.map(this.values, (valueField, field) => ({
                        field,
                        valueField : valueField === null ? '' : valueField
                    }))
                }
                const formData = new FormData()
                formData.append('data', JSON.stringify(data))

                this.$apiCall('/StepFunnelWeb/AddDataStepFunnel', {
                    method: 'POST',
                    body: formData
                }).then(data => {
                    if (data && data.status && data.status === 200) {
                        this.$store.commit('formValues', this.values)
                        this.$store.commit('formIndex', 3)
                    } else {
                        alert("Si sono verificati degli errori")
                    }
                })
            }
        },

        validation () {
            const numericRegex = /^\d+$/
            const CFRegex = /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i
            const IbanRegex = /^IT\d{2}[ ][a-zA-Z]\d{3}[ ]\d{4}[ ]\d{4}[ ]\d{4}[ ]\d{4}[ ]\d{3}|IT\d{2}[a-zA-Z]\d{22}$/i
            const zipRegex = /^[0-9]{5}$/
            const vatRegex = /^[0-9]{11}$/

            this.errors = []
            let fields = []

            if (['ee-dom', 'gas-dom'].includes(this.form.type)) {
                fields = ['CF', 'Tipo_Doc', 'Num_Doc', 'End_Doc', 'MetodoPagamento', 'Paperless']
                if (this.values.MetodoPagamento === 'CC') {
                    fields.push('Iban', 'Nome_Iban', 'Cognome_Iban', 'CodFiscale_Iban')
                }
            }

            if (['ee-au', 'gas-au'].includes(this.form.type)) {
                fields = ['PIVA', 'MetodoPagamento', 'Paperless', 'CUU']
                if (this.values.MetodoPagamento === 'CC') {
                    fields.push('Iban', 'Nome_Iban', 'Cognome_Iban', 'CodFiscale_Iban')
                }
            }

            fields.forEach(field => {
                const value = this.values[field]

                if (field === 'CF' && !value.match(CFRegex)) {
                    this.errors.push('CF')
                }

                if (field === 'PIVA' && !value.match(vatRegex)) {
                    this.errors.push('PIVA')
                }

                if (field === 'Tipo_Doc' && !this.documenti.includes(value)) {
                    this.errors.push('Tipo_Doc')
                }

                if (field === 'Num_Doc' && !value) {
                    this.errors.push('Num_Doc')
                }

                if (field === 'End_Doc' && !value.match(/^[0-9]+?\/[0-9]+?\/[0-9]{4}$/)) {
                    this.errors.push('End_Doc')
                }

                if (field === 'MetodoPagamento' && !this.metodiPagamento.includes(value)) {
                    this.errors.push('MetodoPagamento')
                }

                if (field === 'Iban' && !value.replace(/\s/g, '').match(IbanRegex)) {
                    this.errors.push('Iban')
                }

                if (field === 'Nome_Iban' && !value) {
                    this.errors.push('Nome_Iban')
                }

                if (field === 'Cognome_Iban' && !value) {
                    this.errors.push('Cognome_Iban')
                }

                if (field === 'CodFiscale_Iban' && !value.match(CFRegex)) {
                    this.errors.push('CodFiscale_Iban')
                }

                if (field === 'Paperless' && !['SI', 'NO'].includes(value)) {
                    this.errors.push('Paperless')
                }

                if (field === 'CUU' && !value) {
                    this.errors.push('CUU')
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/FormStep3/FormStep3.vue